import React from 'react';
import { motion } from 'framer-motion';
import styles from './BlogDetail.module.css';
import { blogPosts } from '../data/blog';

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 },
};

// Component for the LEFT sidebar
const Sidebar = ({ postId }) => {
  const post = blogPosts.find(p => p.id === postId);

  if (!post) {
    return <div>Post not found.</div>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className={styles.blogTitle}>{post.title}</h2>
      {post.tags && (
        <div className={styles.tagContainer}>
          {post.tags.map(tag => (
            <button key={tag} className={styles.tag} onClick={() => console.log('Blog Tag clicked:', tag)}>
              {tag}
            </button>
          ))}
        </div>
      )}
    </motion.div>
  );
};

// Component for the MAIN content area
const Content = ({ postId }) => {
  const post = blogPosts.find(p => p.id === postId);

  if (!post || !post.content) {
    return <div>Post content not available.</div>;
  }

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="in"
      exit="out"
      transition={{ duration: 0.5 }}
    >
      {post.content.map((item, index) => {
        switch (item.type) {
          case 'paragraph':
            return <p key={index} className={styles.description}>{item.value}</p>;
          case 'subheading':
            return <h3 key={index} className={styles.subheading}>{item.value}</h3>;
          case 'image':
            return <img key={index} src={item.value} alt={`${post.title} content ${index + 1}`} className={styles.blogImage} />;
          default:
            return null;
        }
      })}
    </motion.div>
  );
};

const BlogDetail = { Sidebar, Content };
export default BlogDetail;